import React from 'react'

import delve from 'dlv'

import { getDataDependencies, buildStaticPaths } from 'services/api'

import fetchContentType from 'src/lib/Strapi/fetchContentType'
import fetchAllSlugs from 'src/lib/Strapi/fetchAllSlugs'

import SliceManager from 'components/shared/SliceManager'
import PreviewBanner from 'components/shared/PreviewBanner'

const Universals = ({ pageData, preview }) => {
  const slices = delve(pageData, 'slices')

  return (
    <>
      {preview && <PreviewBanner />}
      {slices && <SliceManager slices={slices} />}
    </>
  )
}

export async function getStaticPaths() {
  const data = await fetchAllSlugs('universals')
  const filteredData = data.filter(({ slug }) => slug !== '404')
  return buildStaticPaths(filteredData)
}

export async function getStaticProps({ preview = null, params }) {
  const data = await fetchContentType(
    'universals',
    `filters[slug][$eq]=${params.slug}${
      preview ? '&publicationState=preview' : ''
    }`
  )

  if (data?.length === 0 || !data) {
    return {
      props: {},
      notFound: true,
    }
  }

  const pageData = await getDataDependencies(delve(data, '0'))
  return {
    props: {
      pageData,
      preview,
    },
  }
}

export default Universals
